export default {
    consol_type: "Consol type",
    deviation_reason: "Причина отклонения",
    rejected_by: "Rejected by",
    cfo: "ЦФО",
    brunch: "Бранч",
    chat: "Чат",
    ChatRoomEdit: "Создать групповой чат",
    Notifications: "Уведомления",
    StimulReport: "Отчет",
    airports: "Аэропорты",
    auto: "Автомашины",
    balance_payment_accounts: "Баланс банковских счетов",
    banks: "Банки",
    business_operation: "Бизнес операция",
    business_process: "Бизнес процесс",
    business_process_template: "Шаблоны бизнес процессов",
    capital_accounts: "Финансовые счета",
    capital_transfers: "Проводки",
    capital_transfers_rur: "Переоценка",
    city: "Города",
    class_access_docs: "Разрешительные документы",
    class_access_docs_type: "Типы разрешительных документов",
    class_danger: "Классы опасностей",
    classification: "Классификационный",
    client_gtds_by_years: "Отчет о ДТ по таможням",
    counting_of_loading_units: "Счётчик грузов",
    combiner_all_units: "Сборные грузы",
    combiner_all_units_all: "Сборные грузы (все)",
    combiner_all_units_archive: "Сборные грузы (архив)",
    combiner_all_units_current: "Сборные грузы (текущие)",
    combiner_operations: "Перевозка сборных грузов",
    combiner_remains: "Консолидация сборных грузов",
    company: "Контрагенты",
    company_crm_doc_number_mask: "Шаблоны номеров запросов",
    conact_persons: "Контактные лица",
    contracts: "Реестр договоров",
    contracts_all: "Реестр договоров (все)",
    contracts_archive: "Реестр договоров (архив)",
    contracts_current: "Реестр договоров (текущие)",
    contracts_addition: "Реестр приложений договоров",
    contracts_addition_type: "Вид приложений договора",
    contracts_fea: "Контракты ВЭД",
    contracts_fea_all: "Контракты ВЭД (все)",
    contracts_fea_archive: "Контракты ВЭД (архив)",
    contracts_fea_current: "Контракты ВЭД (текущие)",
    contracts_fea_addition: "Доп. соглашение",
    contracts_type: "Вид договоров",
    country: "Страны",
    country_regions: "Регионы",
    couriers: "Курьеры",
    crm: "Запросы",
    crm_all: "Запросы (все)",
    crm_archive: "Запросы (архив)",
    crm_current: "Запросы (текущие)",
    crm_production: "Продукция",
    curs_eurobank: "Курсы валют Евро",
    curs_internal: "Курсы валют ЦБ",
    delivery_conditions: "Условия поставки",
    department: "Отделы",
    dislocation: "Журнал дислокации",
    rolis_event: "События Ролис",
    rolis_subscription: "Подписки Ролис",
    rolis_edi: "EDI Ролис",
    doc_operation_type: "Типы документальных операций",
    document_management_doc_type: "Типы документов (документооборот)",
    document_management_incoming: "Входящие",
    document_management_outgoing: "Исходящие",
    document_type: "Тип документа",
    drivers: "Водители",
    effex_events_unit: "События Effex",
    etsng: "ЕТСНГ",
    events: "События",
    fin_operation: "Котировки",
    fin_operation_buy: "Фин. операция покупка",
    fin_operation_buy_eastex: "Фин. операция покупка",
    fin_operation_group_unit: "Грузовые места",
    fin_operation_sale: "Фин. операция продажа",
    fin_operation_sale_eastex: "Фин. операция продажа",
    gng: "ГНГ",
    group_operation: "Сборные грузы",
    gtd_result_returning_otp_status: "Статусы результатов проверок из ОТП",
    gtd_additional_check_status: "Статусы решений по доп. проверке",
    gtd_all: "Все таможенные декларации",
    gtd_archive: "Завершенные таможенные декларации",
    gtd_balance: "Баланс контрактов ВЭД",
    gtd_clients_by_years: "Отчет о ДТ по грузополучателям",
    gtd_current: "Текущие таможенные декларации",
    gtd_fact_type: "Типы деклараций",
    gtd_payments: "Баланс таможенных платежей",
    check_customs_payments: "Проверка на невыставленные ТП",
    gtd_post_customs: "Пост таможенный контроль",
    gtds_goods: "Товары по ДТ",
    hook: "Полуприцепы",
    inspectors: "Инспектора",
    invoice_incoming: "Входящие cчета",
    invoice_incoming_money: "Приход ДС",
    invoice_outgoing: "Исходящие cчета",
    invoice_outgoing_doc_number_mask: "Шаблоны номеров счетов",
    invoice_outgoing_money: "Расход ДС",
    leads: "Лиды",
    list_documents: "Документы",
    list_feacc_article: "Артикулы",
    list_feacc_article_all: "Артикулы (все)",
    list_feacc_article_archive: "Артикулы (архив)",
    list_feacc_article_current: "Артикулы (текущие)",
    list_feacc_gtd: "Товары ДТ",
    list_gtd_post_customs_control: "Возвраты денежных средств по доп.проверке",
    list_vat: "НДС",
    logistas_unit: "Грузы",
    manufacturer: "Производители",
    model_auto: "Марки автомобилей",
    moved_orders_positions: "Товародвижение",
    name_weight: "Наименования грузов",
    noty_table: "Уведомления",
    operation_air: "Авиационные операции",
    operation_auto: "Автомобильные операции",
    operation_cargo_status_ex_t1: "Статус груза ЕХ/Т1",
    operation_customs: "Таможенные",
    operation_detail: "Детализация операции",
    operation_documentation: "Документальная операция",
    operation_forward: "Экспедирование",
    operation_other: "Иная операция",
    operation_packing_unit_type: "Единицы измерения",
    operation_rate_expense_category: "Категории номенклатуры",
    operation_custom_status_type: "Статус коносамента",
    operation_rate_expense_include: "Детализация номенклатуры",
    operation_rate_expense_type: "Номенклатуры услуг",
    operation_repacking: "Перетарка",
    operation_sea: "Букинги",
    operation_sub_doc_auto_menu: "Автомобильные",
    operation_auto_submenu: "Автомобильные операции",
    operation_sub_doc_auto: "ТТН/CMR",
    operation_sub_doc_auto_current: "ТТН/CMR (текущие)",
    operation_sub_doc_auto_all: "ТТН/CMR (все)",
    operation_sub_doc_auto_archive: "ТТН/CMR (архив)",
    auto_transportation: "Автомобильные перевозки",
    auto_transportation_current: "Автомобильные перевозки (текущие)",
    auto_transportation_archive: "Автомобильные перевозки (архив)",
    auto_transportation_all: "Автомобильные перевозки (все)",
    operation_sub_doc_forward: "Досмотры/Осмотры",
    operation_sub_doc_sea: "Коносаменты",
    operation_sub_doc_train: "Железнодорожные",
    operation_sub_doc_train_current: "Железнодорожные (текущие)",
    operation_sub_doc_train_all: "Железнодорожные (все)",
    operation_sub_doc_train_archive: "Железнодорожные (архив)",
    operation_sub_doc_air: "Авиационные документы",
    operation_sub_doc_repacking: "Документы перетарки",
    operation_sub_doc_customs: "Документы таможенного оформления",
    operation_train: "Железнодорожные операции",
    operation_type: "Типы операций",
    operation_unit: "Грузы",
    operation_unit_all: "Грузы (все)",
    operation_unit_archive: "Грузы (архив)",
    operation_unit_current: "Грузы (текущие)",
    operation_unit_division: "Тип груза",
    order_doc_number_mask: "Шаблоны номеров заказов",
    order_docs_scheme: "Шаблоны документальных схем",
    order_request: "Шаблоны логистических схем",
    order_units_by_years:
    "Доходность по сделкам (группировка по типам перевозок)",
    order_profit_by_operation_type_by_years:
        "Доходность по сделкам (группировка по типам)",
    orders: "Заказы",
    orders_all: "Заказы (все)",
    orders_archive: "Заказы (архив)",
    orders_current: "Заказы (текущие)",
    owner_unit: "Экспортные перевозки",
    own_rolling_stock_unit: "Собственный подвижной состав",
    own_rolling_stock_unit_current: "Собственный подвижной состав (текущие)",
    own_rolling_stock_unit_archive: "Собственный подвижной состав (архив)",
    own_rolling_stock_unit_all: "Собственный подвижной состав (все)",
    part_number: "Инвойсы",
    part_number_prepare_declaration: "Подготовка деклараций",
    payment_orders: "Платежи",
    payments_by_bank: "Отчет о прибылях и убытках (Расширенный)",
    payments_gtd_link: "Таможенные платежи",
    payments_incoming: "Полученные ПП",
    payments_incoming_swift: "Полученные SWIFT",
    payments_incoming_cash: "Полученные наличные ДС",
    payments_outgoing: "Отправленные ПП",
    payments_outgoing_swift: "Отправленные SWIFT",
    payments_outgoing_cash: "Отправленные наличные ДС",
    permission: "Права доступа",
    person_posts: "Должности",
    positions_in_orders_all: "Спецификации",
    railways: "Железные дороги",
    rate_expenses: "Котировки",
    rate_expenses_type: "Номенклатуры услуг",
    report_capital_balance: "Баланс",
    report_capital_turnover: "Оборотная ведомость",
    request_auto: "Заявка на автоперевозку",
    request_currency_translation: "Валютные переводы",
    request_forward: "Заявки на экспедирование",
    request_sea: "Заявка на морскую перевозку",
    request_train: "Заявка на подвижной состав",
    requests: "Запросы",
    sea_rates: "Морские котировки",
    settings: "Настройки",
    tasks: "Задачи",
    tasks_current: "Задачи (текущие)",
    tasks_archive: "Задачи (архив)",
    tasks_all: "Задачи (все)",
    tasks_operation_unit: "Задачи (грузовая единица)",
    tnved: "ТНВЭД",
    tp_els: "График ТП",
    train_current: "Поезда (текущие)",
    train_archive: "Поезда (архив)",
    train_all: "Поезда (все)",
    train_number_mask: "Шаблоны номеров поездов",
    transfer_points: "Точки маршрута",
    type_unit: "Единицы измерения",
    unit_type_carriage: "Типы вагонов",
    unit_type_containers: "Типы контейнеров",
    unit_type_van: "Типы кузовов",
    user_task_theme: "Шаблоны задач",
    users: "Учетные записи",
    vessel: "Суда",
    weight_group: "Группа товаров",
    work_instructions: "Рабочие инструкции",
    credit_late_invoices: "Кредиторская задолженность",
    debit_late_invoices: "Дебиторская задолженность",
    client_payment_balance: "Баланс с клиентом",
    crm_request_status: "Статус запроса",
    request_status_crm: "Статусы запроса",
    request_gtd: "Заявления (ВДТ)",
    part_number_position: "Таможенная аналитика",
    company_crm_event_type: "Типы событий CRM",
    list_contact_persons_email_broadcast_config: "Рассылка документов",
    document_status: "Статус документов",
    template_invoice_post: "Шаблоны расходов",
    template_invoice: "Шаблон расхода",
    order_notifications: "Рассылка по заказам",
    list_gtd_notifications: "Рассылка по точкам маршрута",
    auto_rates: "Авто котировки",
    sea_port_expenses: "Локальные затраты в порту",
    commercial_offer: "Коммерческие предложения",
    order_profit_by_general: "Фин результат",
    person_to_notify: "Сторона получения уведомления (notify)",
    storage_rates: "Тарифы хранения",
    supermarket_type: "Торговые сети",
    capital_conversion_operation: "Конверсионные операции",
    prepayment_report: "Отчет по авансам",
    list_company_groups: "Группы контрагентов",
    list_company_category: "Категория контрагента",
    list_company_category_group: "Группа категорий",
    criteria: "Критерии контрагентов",
    work_instructions_document: "Документы инструкций",
    work_instructions_category: "Категории инструкций",
    capital_operation_form: "Проводки для форм",
    gtd_units_report: "ДТ Континентал",
    docs_send_method: "Способ отправки документов",
    payment_orders_incoming_doc_number_mask:
    "Шаблоны номеров Полученных наличных ДС",
    payment_orders_outgoing_doc_number_mask:
    "Шаблоны номеров Отправленных наличных ДС",
    template_notification_mailing_doc: "Шаблоны рассылки документов",
    template_notification_mailing: "Шаблоны рассылки уведомлений",
    profit_report: "Отчет по доходам",
    late_invoices_without_unaccounted_report:
    "Дебиторская задолженность без неучитываемых в ДЗ",
    batch_fin_operation_buy: "Пакетные фин операции покупка",
    prepare_declaration: "Подготовка ДТ",
    counterparty_balance_report: "Баланс с контрагентами",
    cost_price_report: "Себестоимость",
    article_report: "Отчет по артикулам",
    dynamic_journals: "Клиентские журналы",
    product: "Job Solution",
    move_type: "Move type",
    biz_scope: "BizScope",
    bl_type: "BL type",
    ctrl: "Ctrl/non-ctrl",
    Заказы: "Заказы",
    Грузы: "Грузы",
    Морские: "Морские",
    Капитал: "Капитал",
    Железнодорожные: "Железнодорожные",
    Экспедирование: "Экспедирование",
    Документооборот: "Документооборот",
    Декларирование: "Декларирование",
    finance: "Финансы",
    Аналитика: "Аналитика",
    "Финансовые отчеты": "Финансовые отчеты",
    "Отчеты по ДТ": "Отчеты по ДТ",
    "Оперативные отчеты": "Оперативные отчеты",
    "Сводные отчеты": "Сводные отчеты",
    "Отчеты по клиентам": "Отчеты по клиентам",
    Справочники: "Справочники",
    list_reusable: "Перечень многооборотной тары",
    list_reusable_containers: "Многооборотная тара",
    settings_finance: "Настройки (финансы)",
    "Кредиторская задолженность": "Кредиторская задолженность",
    "Дебиторская задолженность": "Дебиторская задолженность",
    "Неперевыставленные затраты": "Неперевыставленные затраты",
    "Финансовый результат": "Финансовый результат",
    "Акт сверки": "Акт сверки",
    Отчеты: "Отчеты",
    templates: "Шаблоны",
    types_classes: "Типы, классы",
    geographic_features: "Географические объекты",
    foreign_trade_contracts: "Контракты ВЭД",
    quotes: "Котировки",
    "Статусы запроса": "Статусы запроса",
    "Статусы документов": "Статусы документов",
    "Статусы решений по доп.проверке": "Статусы решений по доп.проверке",
    "Статусы результатов проверок из ОТП":
    "Статусы результатов проверок из ОТП",
    "Категория контрагента": "Категория контрагента",
    "Группа категорий": "Группа категорий",
    "Вид расхода": "Вид расхода",
    "Группа расхода": "Группа расхода",
    "Подгруппа расхода": "Подгруппа расхода",
    class_access_docs_type_count_44:
    "Наименование, сведения разрешительного документа (графа 44)",
    nomenclature_to_print: "Наименования номенклатур для печати",
    payment_orders_expence_type: "Вид расхода",
    payment_orders_group_expence_type: "Группа расхода",
    payment_orders_subgroup_expence_type: "Подгруппа расхода",
    report_settings: "Настройки бланков",
    logos_lang_translation: "Перевести логось",
    icb_office: "ICB Offices",
    payable_cso: "Payable CSO",
    doc_fin_operation_buy: "Документы фин. операций покупка",
    doc_fin_operation_sale: "Документы фин. операций продажа",
    manager_bonus: "Премии менеджерам",
    invoice_outgoin_money_params: "Параметры расхода ДС",
    alta_cbx_data: "СВХ",
    alta_cbx_data_all: "Партии (все)",
    alta_cbx_data_current: "Партии (текущие)",
    alta_cbx_data_archive: "Партии (архив)",
    courier: "Курьеры",
    capital_expenses: "Доходы/Расходы",
    financial_result_report: "Финансовый результат new",
    receivables_report: "Движение денежных средств",
    capital_transfer_template: "Шаблоны проводок",
    export_units_report_choose: "Отчет по экспортным перевозкам",
    train_menu: "Поезда",
    list_contracts: "Договоры",
    contracts_application: "Приложения договоров",
    industry: "Индустрии",
    risk_class: "Классы риска",
    crm_request_type: "Источники запросов",
    list_ownership_type: "Типы владения",
    service_combination: "Комбинация услуг",
    purchasing_document_report: "Формирование отчетов в ФТС",
    ghq_activity: "GHQ Activity",
    preliminary_gtd_status: "Предварительный статус ДТ",
    template_payment_schedule: "Шаблоны графика платежей",
    payment_schedule: "График платежей",
    branch_yunas: "Branch Yunas",
    data_changes_log_yunas: "Загрузка XML Yunas",
    sample_collection: "Отбор проб",
    wht: "WHT",
    fin_operation_commercial_offer: "Фин. операции по коммерческим предложениям",
    company_subdivision: "Подразделение",
    forwarding_service_report: "Отчет по результатам работы ТЭО"
};
